var _path, _path2, _path3, _path4, _ellipse, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _ellipse2, _path32, _path33, _path34, _path35, _path36, _g, _path37, _g2, _g3, _g4, _g5, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g6, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _g7, _path80, _path81, _path82, _ellipse3, _g8, _path83;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTest4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 779.23 900.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.28 354.17c0-19.7 34.1-35.67 76.23-35.74v-52.38c0-19.74 34.25-35.75 76.51-35.75s76.51 16 76.51 35.75v71.38l2.05 4.87.94 1.77c.69 1.29.2 2.23 1.64 2.27 40.23 1.05 72.16 16.63 72.16 35.69v79.25c15.77 17.77 14.75 37.74 0 59.5v31.12c0 19.74-34.25 35.75-76.51 35.75h-.28v36.73c0 19.74-34.25 35.74-76.51 35.74-32.57 0-60.39-9.51-71.43-22.91-1.59.05-3.19.07-4.8.07-42.25 0-76.51-16-76.51-35.75V354.17z",
    fill: "#d30334",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M399.74 403.11v169.81c8.53 5.52 18.15 9.09 28.48 11.35V414.22c-11.34-2.56-21.11-6.4-28.48-11.11zm43.28 13.61v169.91c-2.45-.26-4.87-.58-7.26-.95V415.7c2.37.39 4.79.74 7.26 1.02zM322.95 286.59v32.48c10.39.93 20.04 2.84 28.48 5.51V297.7c-11.34-2.57-21.11-6.4-28.48-11.11zm43.28 13.61v30.52a75.223 75.223 0 00-7.26-3.4v-28.14c2.37.4 4.79.74 7.26 1.02zM322.95 636.64v8.72c8.53 5.52 18.15 9.09 28.48 11.35v-25.59c-11.13 2.93-18.86 4.35-28.48 5.52zm43.28-11.25v33.68c-2.45-.26-4.87-.58-7.26-.95v-29.71c2.58-1.11 4.65-2.08 7.26-3.01z",
    fill: "#74042b",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M446.97 433.04v23.39c-3.32-.3-6.57-.7-9.72-1.19v-23.39c3.15.49 6.4.89 9.72 1.19zm-15.08 21.26c-3.37-.66-6.62-1.43-9.72-2.31V428.6c3.1.87 6.35 1.64 9.72 2.31v23.39zm-15.08-3.96c-3.47-1.17-6.72-2.47-9.72-3.89v-23.39c3 1.42 6.25 2.72 9.72 3.89v23.39z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232 459.19v142.34c0 19.74 34.25 35.75 76.51 35.75s76.51-16 76.51-35.75V354.17c0 19.74-34.25 35.75-76.51 35.75s-76.51-16-76.51-35.75v105.02z",
    fill: "#5e8c7c",
    fillRule: "evenodd"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.51,
    cy: 588.27,
    rx: 76.51,
    ry: 35.75,
    fill: "#50b58b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M302.61 552.63c1.95-.07 3.92-.11 5.9-.11 29.59 0 55.25 7.85 67.98 19.33",
    fill: "none",
    stroke: "#008c63",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M442.51 289.78v15.88c-8.85 3.86-18.86 7.88-29.18 9.15v-15.39c11.3-2.11 21.28-5.43 29.18-9.63zm0 306.32v51.42c-9.39 4.89-19.14 8.15-29.18 10.14v-40.02c10.92-5.91 21.12-13.37 29.18-21.55zm-41.12-294.98v46.51c-1.71 4.21-3.49 8.34-5.34 12.32-2.62 1.03-5.01 2.17-7.13 3.38v-61.44c4.26-.1 8.42-.37 12.47-.78zm0 322.24v36.07c-4.12.42-8.28.65-12.47.72v-32.37c4.14-1.2 8.32-2.68 12.47-4.42zM489.83 543.07l29.18-16.79v49.21c-7.9 4.2-17.88 7.53-29.18 9.63v-42.05zm-11.94-126.12v35.69l-7.23 8.5-5.24 7.02v-50.43c4.26-.1 8.42-.37 12.47-.78zm41.12-11.34v36.74c-10.26-8.14-19.91-7.51-29.18-1.68v-25.43c11.3-2.1 21.28-5.43 29.18-9.63zm-41.12 181.21c-4.05.41-8.21.68-12.47.78v-33.73c3.49.02 7.21-.96 11.09-3.18l1.38-.79v36.92z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.45 373.73v194.99c6.54-4.67 15.35-8.57 25.69-11.38V385.11c-10.35-2.81-19.15-6.71-25.69-11.38zm36.2 13.75v167.49c3.54-.65 7.21-1.17 10.98-1.57V389.05c-3.77-.4-7.44-.92-10.98-1.57z",
    fill: "#8ac694",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#74042b",
    fillRule: "evenodd",
    d: "M539.84 461.57l9.29 20.48-32.21-2.46-3.69-16.15 15.39-4.39 11.22 2.52z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M523.89 532.81l-19.98-.43-6.74-14.6-2.21-13.52 9.1-4.2 19.83 32.75zm15.79-13.94l-31.95-28.02-3.04 6.18 24.25 32.59 10.75-10.75z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M500.85 525.76c8.7 9.28 22.07 10.23 31.75 1.3 10.65-9.82 20.78-30.05 16.13-47.56-1.55-5.82-5.22-11.63-11.92-18.61l-.91 4.53c7.49 13.88 4.99 29.92-.08 40.3-7.37 15.07-15.86 25.15-34.97 20.04z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M541.46 464.3c-2.1-1.38-3.88-2.62-4.64-3.4l-3.48-.29 2.56 4.8c2.79 5.16 4.19 10.62 4.59 15.97l4.38.33 5.15.39c-.88-7.36-4.44-13.69-8.56-17.82z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#74042b",
    fillRule: "evenodd",
    d: "M466.99 514.89l-3.53-21.75 31.5 11.12 3.31 18.36-31.28-7.73z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M487 444.35l16.12-7.92 23.34 22.79-12.63 5.82-26.83-20.7zm-11.89 11.79l30.03 20.46 4.32-8.78-27.5-20.28-6.85 8.6z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M520.53 443.19c-3.33-3.63-8.39-5.74-10.8-6.29-16.99-3.87-36.54 13.58-43.67 38.98-6.34 22.59-.72 43.86 12.56 51.01 2.26 1.21 5.09 2.08 7.61 2.42M496.69 517.43c1.67 1.3 3.56 2.23 5.67 2.71 11.47 2.61 24.66-9.16 29.47-26.3 4.15-14.8.7-28.75-7.7-33.97",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M495.52 506.66c.98.63 2.05 1.08 3.21 1.35 8.13 1.85 17.5-6.5 20.91-18.66 3-10.7.4-20.77-5.81-24.31-7.06 5.63-13.1 14.84-16.21 25.93-1.52 5.41-2.19 10.73-2.1 15.69z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M510.32 489.3l19.85 9.45M517.33 482.91l16.03 2.94M516.76 475.37l16.23-.68M514.82 469.34l13.83-3.82"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M496.68 498.66c.64.41 1.34.71 2.1.88 5.32 1.21 11.43-4.25 13.66-12.2 1.96-6.99.26-13.58-3.8-15.89-4.61 3.68-8.56 9.7-10.6 16.95-.99 3.54-1.43 7.01-1.37 10.25z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M493.33 529.64c3.97.29 7.93.59 11.9.88-8.88-6.97-12.31-22.81-7.61-39.55 5.76-20.52 21.56-34.62 35.29-31.49 1.02.23 1.99.55 2.93.95l-7.93-9.58c-19.27 1.59-29.68 8.33-38.01 27.24-8.3 18.86-6.18 41.17 3.43 51.55z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M497.68 519.33c-1.25-3.53-1.97-7.54-2.13-11.83l-.58-3.24-10.19-3.6c-.24 7.03.75 13.72 2.84 19.32l10.65 2.63-.59-3.28z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M504.24 475.98c1.16-1.84 2.41-3.56 3.73-5.14l1.49-3.03-8.74-6.44c-2.27 2.22-4.34 4.84-6.27 7.95l9.78 6.66zm9.6-10.94l-9.1-7.02c4.09-2.89 8.81-4.78 14.41-5.95l7.32 7.14c-4.3.59-8.63 2.63-12.62 5.82z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M527.26 451.65c-.26-.06-1.51-.44-1.78-.49-15.25-2.82-32.53 12.9-38.9 35.59-5.16 18.4-1.6 35.83 7.88 43.93",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4,
    d: "M538.51 461.88l-18.5-19.23"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M500.85 525.76c3.21 3.43 7.07 5.72 11.14 6.8l9.92.22c.56-.12 1.13-.27 1.69-.45l-4.29-7.09c-4.86 2.17-10.8 2.56-18.45.52zm38.67-6.73l.13-.18-7.39-6.48c-2.5 4.16-5.25 7.68-8.56 10.23l5.23 7.03 10.59-10.6z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M523.25 510.58l-13.56-12.9M514.35 518.12l-9.9-15.1M504.98 520.49l-5.45-15.69"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M532.91 459.48c-13.73-3.13-29.53 10.97-35.29 31.49-5.76 20.52.7 39.69 14.43 42.82 13.73 3.13 29.53-10.97 35.29-31.49 5.76-20.52-.7-39.69-14.43-42.82z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M501.59 525.81c1.25.68 2.6 1.19 4.03 1.51 12.88 2.94 27.71-10.3 33.12-29.56 4.61-16.42.88-31.91-8.29-37.95",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4,
    d: "M512.05 533.8l-27.06-4.72"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M538.08 405.64c-8.13 15.81-39.32 27.58-76.55 27.58s-68.54-11.82-76.6-27.67M463.66 496.01c-.71 0-1.42.01-2.14.01-37.31 0-68.54-11.82-76.6-27.67M477.9 570.43c-9.65-9.67-17.82-21.66-24.93-35.33-33.41-1.66-60.53-12.84-67.95-27.45",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M537.51 543.68c-8.13 15.8-39.32 27.58-76.55 27.58s-68.54-11.82-76.6-27.67M461 616.16c-8.12 15.8-39.32 27.58-76.55 27.58-19.42 0-37.2-3.2-50.92-8.51",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M436.23 585.74c-8.65 3.42-18.95 5.99-30.29 7.43v49.81",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M538.2 520.67v31.23c0 19.74-34.25 35.75-76.51 35.75s-76.51-16-76.51-35.75V382.03c0 19.74 34.25 35.75 76.51 35.75s76.51-16 76.51-35.75v80.16",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.51,
    cy: 354.17,
    rx: 76.51,
    ry: 35.75,
    fill: "#babac1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M231.71 585.14v16.02c0 19.74 34.25 35.75 76.51 35.75s76.51-16 76.51-35.75v-16.02c0 19.74-34.25 35.75-76.51 35.75s-76.51-16-76.51-35.75zM232 354.17v16.03c0 19.74 34.25 35.75 76.51 35.75s76.51-16 76.51-35.75v-16.03c0 19.74-34.25 35.75-76.51 35.75s-76.51-16-76.51-35.75z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M312.13 636.87c4.26-.1 8.42-.37 12.47-.78v-16.03c-4.05.41-8.21.68-12.47.78v16.03zm24.41-2.48c11.3-2.11 21.28-5.43 29.18-9.63v-16.03c-7.9 4.2-17.88 7.53-29.18 9.63v16.03zM312.13 406.05c4.26-.1 8.42-.36 12.47-.78v-16.03c-4.05.41-8.21.68-12.47.78v16.03zm24.41-2.48c11.3-2.1 21.28-5.43 29.18-9.63v-16.03c-7.9 4.2-17.88 7.53-29.18 9.63v16.03z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M280.96 387.53v16.03c3.29.59 6.68 1.08 10.17 1.46v-16.03c-3.49-.38-6.88-.87-10.17-1.46zm-36.75 2.05c7.21 5.21 17.23 9.48 29.06 12.36v-16.03c-11.83-2.87-21.86-7.15-29.06-12.36v16.03zM280.96 618.55v16.03c3.29.59 6.68 1.07 10.17 1.44v-16.03c-3.49-.37-6.88-.86-10.17-1.44zm-36.75 2.2c7.24 5.16 17.26 9.39 29.06 12.23v-16.03c-11.8-2.84-21.82-7.07-29.06-12.23v16.03z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M308.51 609.45c25.64 0 46.54-9.77 46.54-21.75s-20.91-21.75-46.54-21.75-46.55 9.77-46.55 21.75 20.91 21.75 46.55 21.75z",
    fill: "none",
    stroke: "#008c63",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M465.73 346.34c40.3 1.02 72.31 16.61 72.31 35.69s-34.25 35.75-76.51 35.75-76.51-16-76.51-35.75c0-5.74 2.9-11.16 8.04-15.97l-.18.43 57.38 20.08 31.11-10.85-15.66-29.38z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.51 600.04c14.55 0 26.41-5.54 26.41-12.34s-11.87-12.34-26.41-12.34-26.41 5.54-26.41 12.34 11.87 12.34 26.41 12.34z",
    fill: "#008c63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.51 587.14c10.56 0 19.2 3.85 19.84 8.71-4.84 2.57-11.93 4.19-19.84 4.19s-14.99-1.62-19.83-4.19c.64-4.86 9.27-8.71 19.83-8.71z",
    fill: "#006445"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M383.09 381.71l-3.64 2.6v19.6c1.51-5.45 2.72-11.15 3.64-17.09v-5.1zm-3.64 217.64v1.52l1.91-2.17c-.64.22-1.27.44-1.91.65zM233.91 381.71l3.63 2.59v216.56l-3.63-4.13V381.71z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.76 568.98c5.26 0 9.54-4.29 9.54-9.55s-4.29-9.54-9.54-9.54-9.55 4.29-9.55 9.54 4.29 9.55 9.55 9.55z",
    fill: "#8ac694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.52 556.44c1.94-1.45 5.13-.44 7.13 2.25 2 2.68 2.04 6.03.1 7.48-1.94 1.44-5.13.44-7.13-2.25-2-2.68-2.04-6.03-.1-7.48z",
    fill: "#a6d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.67 553.29c1.18-.88 3.13-.27 4.34 1.37 1.22 1.63 1.24 3.67.06 4.55-1.18.88-3.13.27-4.34-1.37-1.22-1.63-1.25-3.67-.06-4.55z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.01 543.74c3.9 0 7.08-3.18 7.08-7.08s-3.18-7.08-7.08-7.08-7.08 3.18-7.08 7.08 3.18 7.08 7.08 7.08z",
    fill: "#8ac694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.38 534.44c1.44-1.07 3.81-.33 5.29 1.67 1.48 1.99 1.52 4.48.08 5.55-1.44 1.07-3.81.33-5.29-1.67s-1.52-4.48-.08-5.55z",
    fill: "#a6d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.43 532.1c.88-.65 2.32-.2 3.22 1.01.9 1.21.92 2.72.05 3.38-.88.65-2.32.2-3.22-1.01-.9-1.21-.92-2.73-.05-3.38z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.74 494.76c6.12 0 11.11-4.99 11.11-11.11s-4.99-11.11-11.11-11.11-11.11 4.99-11.11 11.11 4.99 11.11 11.11 11.11z",
    fill: "#8ac694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.47 480.17c2.26-1.68 5.98-.51 8.3 2.61 2.33 3.12 2.38 7.02.12 8.7-2.26 1.68-5.98.51-8.3-2.61-2.33-3.12-2.38-7.02-.12-8.7z",
    fill: "#a6d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.96 476.5c1.38-1.02 3.64-.31 5.05 1.59 1.42 1.9 1.45 4.28.07 5.3-1.38 1.02-3.64.31-5.05-1.59-1.42-1.9-1.45-4.27-.07-5.3z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.12 451.19c6.98 0 12.67-5.69 12.67-12.67s-5.69-12.67-12.67-12.67-12.67 5.69-12.67 12.67 5.69 12.67 12.67 12.67z",
    fill: "#8ac694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.84 434.55c2.58-1.92 6.82-.58 9.47 2.98 2.65 3.56 2.71 8.01.14 9.93-2.58 1.92-6.82.58-9.47-2.98-2.65-3.56-2.71-8.01-.14-9.93z",
    fill: "#a6d2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.66 430.36c1.57-1.17 4.15-.36 5.77 1.82s1.65 4.88.08 6.04c-1.57 1.17-4.15.35-5.77-1.82-1.62-2.17-1.65-4.88-.08-6.05z",
    fill: "#fff"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M232 459.19V354.17c0 19.74 34.25 35.75 76.51 35.75s76.51-16 76.51-35.75v247.36c0 19.74-34.25 35.75-76.51 35.75s-76.51-16-76.51-35.75v-79.15",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M365.71 393.93v38.75c-.55.91-1.12 1.82-1.7 2.72-8.07 12.56-12.5 24.54-12.5 39.54v31.52l-11.98 5.27c4.56 3.04 8.47 6.58 11.98 10.46v3.15l-2.12 1.84c-7.38 6.41-8.57 15.36-8.57 24.91 0 6.58 1.31 24.56 10.69 24.57V585c0 10.14 4.08 21.2 14.2 22.23v2.3c-9.46 4.15-19.18 7.13-29.18 8.98V403.48c11.29-2.08 21.26-5.37 29.18-9.54zm-41.12 11.22v214.96l-12.47.73V405.9c4.26-.09 8.42-.35 12.47-.75z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M253.58 533.86c-17.78.22-27.64-15.91-31.81-28.15-4.11-12.05-4.23-33.23 6.41-44.45 6.7-6.39 13.39-12.78 20.09-19.18 16.11-12.08 33.95-1.86 43.82 12.88 8.93 13.33 13.62 28.43 12.21 44.57-1.13 12.97-6.58 25.17-18.59 28.58-10.7 1.92-21.41 3.83-32.11 5.75z",
    fill: "#d30334",
    fillRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M267.42 525.51c-8.7 9.28-22.07 10.23-31.75 1.3-10.65-9.82-20.79-30.05-16.13-47.56 1.55-5.82 5.22-11.63 11.92-18.61l.91 4.53c-7.49 13.88-5 29.92.08 40.3 7.37 15.07 15.86 25.15 34.97 20.04z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#74042b",
    fillRule: "evenodd",
    d: "M277.26 439.8l-12.97-3.72-14.65 2.74-18.44 21.76 18.33 1.05 27.73-21.83z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#74042b",
    fillRule: "evenodd",
    d: "M228.17 461.26l-9.28 20.48 32.21-2.46 3.69-16.15-15.39-4.39-11.23 2.52z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M228.17 461.26l-9.29 20.48 8.84-.68c.72-8.13 3.34-15.18 7.46-21.38l-7.01 1.57z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M301.79 471.46l-8.93-14.13L264.48 475l5.8 11.4 31.51-14.95zm2.5 16.06l-32.89 12.89-1-9.74 31.53-13.63 2.37 10.48zM224.54 511.43l9.77 11.56 29.65-18.89-12.52-8.86-26.9 16.18zm-3.4-11.77l30.66-15.96.94 8.05-29.82 14.46-1.77-6.56z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M224.54 511.43l9.77 11.56 7.18-4.57-7.09-9.09-1.25-3.07-8.61 5.18zm4.29-15.77l2.62 6.42-8.54 4.14-1.77-6.56 7.69-4z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M247.48 442.88c3.33-3.63 8.39-5.74 10.8-6.29 16.99-3.87 36.54 13.58 43.67 38.98 6.34 22.59.72 43.86-12.56 51.01-2.26 1.22-5.09 2.08-7.61 2.42M271.32 517.12c-1.67 1.3-3.56 2.23-5.67 2.71-11.47 2.61-24.66-9.16-29.47-26.3-4.15-14.8-.7-28.75 7.7-33.97",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M272.49 506.36c-.98.63-2.05 1.08-3.21 1.35-8.13 1.85-17.5-6.5-20.91-18.66-3-10.7-.4-20.77 5.81-24.3 7.06 5.63 13.1 14.84 16.21 25.93 1.52 5.41 2.19 10.73 2.1 15.69z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M257.7 488.99l-19.85 9.45M244.77 510.27l13.56-12.9M253.66 517.81l9.9-15.1M263.04 520.18l5.45-15.69M250.68 482.6l-16.03 2.94M251.26 475.06l-16.23-.68M253.2 469.03l-13.83-3.82"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M271.34 498.35c-.64.41-1.34.71-2.1.88-5.32 1.21-11.43-4.25-13.67-12.2-1.96-6.99-.26-13.58 3.79-15.89 4.62 3.68 8.56 9.7 10.6 16.95.99 3.54 1.43 7.01 1.37 10.25z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M274.94 529.4c-3.97.29-7.94.59-11.9.88 8.88-6.97 12.31-22.81 7.61-39.55-5.76-20.52-21.56-34.62-35.29-31.49-1.02.23-1.99.55-2.93.95l7.93-9.58c19.27 1.59 29.68 8.33 38.01 27.24 8.3 18.86 6.18 41.17-3.43 51.55z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M249.59 461.58c-4.66-2.49-9.56-3.41-14.22-2.35-1.02.23-1.99.55-2.93.95l7.93-9.58c7.04.58 12.9 1.85 17.9 4.15l-8.68 6.83z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M266.69 525.56c-1.25.68-2.6 1.19-4.03 1.51-12.89 2.94-27.71-10.3-33.12-29.56-4.61-16.42-.88-31.91 8.29-37.95",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M272.46 499.99c-.33-3.02-.92-6.12-1.8-9.26l-.05-.15 10.66-4.61c.91 3.26 1.53 6.56 1.9 9.83l-10.71 4.19zm1.42-30.83l-9.39 5.85 5.8 11.4 9.67-4.59c-.48-1.34-1-2.66-1.58-3.97-1.43-3.24-2.92-6.13-4.5-8.69z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M241.13 451.12c.33-.08 1.28-.24 1.61-.3 15.2-2.64 32.36 13.04 38.7 35.62 5.17 18.4 1.6 35.83-7.88 43.93",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M235.11 459.17c13.73-3.13 29.53 10.97 35.29 31.49 5.76 20.52-.7 39.69-14.43 42.82-13.73 3.13-29.53-10.97-35.29-31.49-5.76-20.52.7-39.69 14.43-42.82zM229.5 461.57l18.5-19.23M255.97 533.49l27.05-4.71M465.31 346.32c40.63.85 73.01 16.52 73.01 35.71s-34.25 35.75-76.51 35.75-76.51-16-76.51-35.75c0-11.17 10.96-21.14 28.12-27.69",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M471.18 356.06c26.27 2.09 46.25 12.54 46.25 25.12 0 14.08-25.03 25.5-55.9 25.5s-55.9-11.42-55.9-25.5c0-7.34 6.79-13.95 17.66-18.6",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M474.48 362.25c17.78 2.43 30.69 9.74 30.69 18.37 0 10.62-19.54 19.23-43.64 19.23s-43.64-8.61-43.64-19.23c0-5.07 4.44-9.67 11.71-13.11M385.06 377.79c-8.13 15.8-39.32 27.58-76.55 27.58s-68.54-11.81-76.6-27.67",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M384.94 450.81c-10.04 12.21-23.86 20.59-42.48 24.14l.92.92 88.88-.27c-19.76-3.57-37.21-9.86-47.32-24.79z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M384.94 450.81c-6.36 7.73-14.24 13.93-23.9 18.34s35.63 6.56 35.63 6.56h.06l35.44-.11-.02-.02c-19.72-3.57-37.13-9.86-47.22-24.77z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M385.02 450.92c-10.34 12.57-24.69 21.08-44.16 24.45l.02.64 91.46-.29v-.28c-19.46-3.5-37.36-9.79-47.32-24.51z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d6f7a",
    d: "M340.78 475.69h91.48v34.72h-91.48z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#45454d",
    fillRule: "evenodd",
    d: "M348.03 510.41h26.3l29.97-34.72h-28.14l-28.13 34.72z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M340.78 475.69h91.48v34.72h-91.48z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.69 487.89h15.78v11.25h-15.78zM378.63 487.89h15.78v11.25h-15.78zM404.57 487.89h15.78v11.25h-15.78z"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M384.78 593.31c-8.13 15.8-39.32 27.58-76.55 27.58s-68.54-11.81-76.6-27.66",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M308.22 318.17v-52.12c0 19.74 34.25 35.75 76.51 35.75s76.51-16 76.51-35.75v75.27m0 246.47v36.57c0 19.74-34.25 35.75-76.51 35.75-32.7 0-60.61-9.58-71.56-23.07",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M425.79 400.56l8.84-5.11M488.98 395.45l8.92 5.14"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#45454d",
    fillRule: "evenodd",
    d: "M414.21 316.47l-1.21-.18.33 37.87 36.53 30.64-35.65-68.33z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M444.19 304.89c-10.21 4.6-20.14 7.98-29.69 9.71l37.66 71.31 29.22-10.19-37.2-70.83z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#babac1",
    fillRule: "evenodd",
    d: "M443.02 368.6l9.14 17.31 8.6-3 4.55-37.81-14.2-27.02-8.09 50.52z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M413.32 314.81l37.51 70.39 30.55-9.49-37.63-70.6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M451.01 385.76l-37.68-31.6v-39.35"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M439.29 317.24c2.11 4.15 4.22 8.29 6.33 12.43-1.64.51-3.28 1.02-4.91 1.53-1.64.51-3.27 1.01-4.91 1.52-2.11-4.14-4.22-8.28-6.33-12.43 1.63-.51 3.27-1.01 4.91-1.52 1.63-.51 3.27-1.02 4.91-1.53h0zm20.8 40.85c2.11 4.15 4.22 8.28 6.32 12.42-1.64.51-3.28 1.02-4.91 1.53-1.64.51-3.27 1.01-4.91 1.52-2.11-4.13-4.21-8.27-6.32-12.42 1.63-.51 3.27-1.01 4.91-1.52 1.64-.51 3.27-1.01 4.91-1.53h0zm-10.4-20.42c2.11 4.14 4.22 8.29 6.33 12.43-1.64.51-3.28 1.02-4.91 1.53-1.64.51-3.27 1.01-4.91 1.52-2.11-4.14-4.21-8.28-6.32-12.42 1.63-.51 3.27-1.01 4.91-1.52 1.63-.51 3.27-1.02 4.91-1.53z",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M487.3 365.04l7.39-4.27M461.28 289.67c-8.12 15.8-39.32 27.58-76.55 27.58s-68.54-11.82-76.6-27.67M406.11 379.49l11.84.05m87.45.12l11.55.02M462.5 406.6v-6.75"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M425.11 626.09v11.75c3.41-.91 6.66-1.94 9.72-3.07V622.9c-3.05 1.18-6.3 2.24-9.72 3.19zm36.14-10.13c-1.44 2.53-3.46 4.95-5.98 7.22v-12.51c2.71-2.66 4.74-5.51 5.98-8.48v13.77zm-11.34 11.34c-2.87 1.91-6.13 3.68-9.72 5.28v-11.96c3.62-1.69 6.88-3.54 9.72-5.54v12.21z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M239.77 369.88l102.39-47.82c9.03 2.07 17.06 4.95 23.66 8.43l-100.16 53.29c-11.02-3.49-19.99-8.28-25.89-13.91zm68.74-51.46c-2.61 0-5.19.06-7.74.18l-67.78 29.81c-.65 1.87-.99 3.79-.99 5.75 0 1.57.22 3.11.64 4.62l87.58-39.95c-3.82-.27-7.72-.42-11.7-.42z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M308.51 372.5c22.27 0 40.43-8.49 40.43-18.89s-18.16-18.89-40.43-18.89-40.43 8.49-40.43 18.89 18.16 18.89 40.43 18.89z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M339.66 333.64c13.17 4.49 21.73 11.76 21.73 19.97 0 7.38-6.92 14-17.89 18.53m-70.13-.06c-10.89-4.53-17.75-11.12-17.75-18.47 0-8.15 8.44-15.38 21.46-19.88M258.61 380.71l22.72-13.12M335.68 367.59L359 381.06M284.89 338.27l-22.1-12.76",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M332.53 338.03l7.11-4.1 14.92-8.61"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.86 343.25c-16.19-1.93-24.43 1.2-29.2 3.96-5.07 2.93-6.71 9.62.94 13.49 4.96-6.63 14.8-7.8 28.27-4.93v-12.52z",
    fill: "#6d6f7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.69 360.23c8.94-7.63 4.45-13.19-10.33-17.18v12.66c3.44 1.51 6.89 3.01 10.33 4.52z",
    fill: "#45454d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.02 354.38V342.9c1.38-.13 2.85-.22 4.44-.24v11.68c-1.55-.07-3.03-.05-4.44.05zm-4.25-10.88c-4.57.89-7.76 2.34-10.11 3.7-.09.05-.18.11-.27.16v12.65c.37.24.77.46 1.2.68 2.17-2.89 5.26-4.75 9.18-5.68V343.5z",
    fill: "#babac1"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M308.51 352.29c9.96 0 18.2 3.46 19.5 7.95-4.39 2.81-11.49 4.64-19.5 4.64s-15.12-1.83-19.5-4.64c1.31-4.49 9.54-7.95 19.5-7.95z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M308.51 358.82c5.93 0 10.91 1.91 12.28 4.48-3.6 1-7.8 1.57-12.28 1.57s-8.68-.57-12.28-1.57c1.37-2.57 6.35-4.48 12.28-4.48z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M308.51 364.87c13.28 0 24.12-5.06 24.12-11.27s-10.83-11.27-24.12-11.27-24.12 5.06-24.12 11.27 10.83 11.27 24.12 11.27z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.51,
    cy: 354.17,
    rx: 76.51,
    ry: 35.75,
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M385.02 230.31c42.25 0 76.51 16 76.51 35.75s-34.25 35.75-76.51 35.75-76.51-16-76.51-35.75 34.25-35.75 76.51-35.75zm-51.42 43.76c8.47 2.58 16.93 5.17 25.4 7.75 11.71 1.86 23.16 2.07 34.37.9 9.71-1.01 24.65-3.37 32.28-9.57 5.46-4.43 6.93-10.56 2.68-19.11-1.35-7.21-5.21-11.89-10.76-14.86-12.76-6.83-40.07-8.72-55.07-3.56l-9.09 3.78c-36.3 1.07-35.7 30.13-19.82 34.67z",
    fill: "#eb6675",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.53 251.49c-5.43 16.7-28.94 19.33-42.22 19.42-14.24.09-38.36-4.84-40.17-20.26-2.14 4.69-4.29 9.37-6.43 14.06 11.56 15.96 29.98 18.54 45.95 18.64 15.39.1 39.32-3.51 48.09-17.37l-5.22-14.49z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.3 270.67a83.09 83.09 0 01-5.18-.59l-.42-.04-2.51 12.45c2.11.29 4.22.49 6.32.62l1.78-12.44zm-11.97-1.94c-5.04-1.26-9.91-3.13-13.82-5.74l-2.55-1.06-3.77 11.46c5.41 4.07 11.52 6.52 17.82 7.97l2.87-12.4-.55-.23z",
    fill: "#45454d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.46 265.83c-2.14.96-4.4 1.75-6.71 2.4l-.84.3 3.73 11.81c3.88-1.03 7.63-2.38 11.04-4.09l-4.76-11.29-2.46.88zm-16.98 16.91a95.1 95.1 0 006.1-.86l-2.71-10.99-5.35.52 1.97 11.34z",
    fill: "#babac1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.39 253.3c-1.8 1.43-3.24 3-4.26 4.66l-1.37 2.23-1.73-1.98c-.94-1.07-1.66-2.18-2.15-3.32-.51-1.18-.77-2.4-.77-3.63 0-2.61 1.17-5.1 3.29-7.36 2.01-2.15 4.92-4.11 8.5-5.78 3.81-1.78 8.36-3.21 13.4-4.18 4.84-.93 10.14-1.44 15.7-1.44s10.86.51 15.7 1.44c5.04.97 9.59 2.4 13.4 4.18 3.59 1.67 6.49 3.64 8.5 5.78 2.12 2.26 3.29 4.75 3.29 7.36 0 1.24-.27 2.45-.77 3.63-.49 1.14-1.22 2.25-2.15 3.32l-1.73 1.98-1.37-2.23c-1.02-1.67-2.47-3.23-4.28-4.67-1.88-1.5-4.15-2.84-6.73-4-3.25-1.46-7.01-2.63-11.1-3.43-3.97-.77-8.27-1.2-12.76-1.2s-8.8.42-12.77 1.2c-4.11.8-7.87 1.98-11.12 3.44-2.57 1.16-4.83 2.5-6.71 4z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.75 237.12c.81.32 1.59.66 2.34 1.01 3.59 1.67 6.49 3.64 8.5 5.78 2.12 2.26 3.29 4.75 3.29 7.36 0 1.24-.27 2.45-.77 3.63-.49 1.14-1.22 2.25-2.15 3.32l-1.73 1.98-1.37-2.23c-1.02-1.67-2.47-3.23-4.28-4.67-1.88-1.5-4.15-2.84-6.73-4-.68-.31-1.39-.6-2.11-.88l5.01-11.29z",
    fill: "#45454d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.99 254.11c12.57 0 22.77 4.76 22.77 10.63 0 1.16-.4 2.27-1.13 3.32-6.3 1.8-13.71 2.84-21.63 2.84s-15.33-1.04-21.63-2.84c-.73-1.04-1.13-2.16-1.13-3.32 0-5.87 10.19-10.63 22.76-10.63z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.5 257.81l-8.62 8.66-5.78-13.71c1.73-1.28 3.74-2.44 6-3.45 1.59-.72 3.3-1.36 5.11-1.93l3.29 10.43zm12.54-2.18l-5.97-.07-2.45-9.95c2.1-.36 4.29-.62 6.55-.78l1.88 10.79z",
    fill: "#eb6675",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.11 252.76l-4.8-11.39c.94-.68 1.98-1.34 3.1-1.97l5.15-2.41c1.25-.49 2.57-.95 3.94-1.37l3.71 11.75c-1.81.57-3.52 1.21-5.11 1.93-2.25 1.02-4.27 2.17-6 3.45zm15.58-19.06c2.37-.41 4.84-.72 7.39-.92l2.09 12.05c-2.25.16-4.44.42-6.55.78l-2.94-11.91z",
    fill: "#babac1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.29 266.89c-.4-3.47-1.71-6.51-4.82-8.69l4.61-10.38c5.99 2.85 10.96 6.04 15.01 11.99-3.78 3.89-9.41 6.89-14.79 7.08z",
    fill: "#74042b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.5 261.01c2.71-9.31 18.02-16.45 36.49-16.45s33.75 7.12 36.48 16.41",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.99 254.11c12.57 0 22.77 4.76 22.77 10.63 0 1.16-.4 2.27-1.13 3.32-6.3 1.8-13.71 2.84-21.63 2.84s-15.33-1.04-21.63-2.84c-.73-1.04-1.13-2.16-1.13-3.32 0-5.87 10.19-10.63 22.76-10.63z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.99 270.9c22.88 0 41.54-8.72 41.54-19.41s-18.66-19.41-41.54-19.41-41.54 8.72-41.54 19.41 18.66 19.41 41.54 19.41z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.81 248.02l5.04 12.05c.68 1.63.59 4.2 0 5.92-3.34 9.82-22.61 17.35-45.87 17.35s-42.52-7.53-45.87-17.35c-.59-1.72-.68-4.29 0-5.92l4.93-11.79",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 384.73,
    cy: 266.05,
    rx: 76.51,
    ry: 35.75,
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.34 243.12c15.5 5.05 25.51 13.06 25.51 22.08 0 15.27-28.71 27.65-64.13 27.65s-64.12-12.38-64.12-27.65c0-9.36 10.78-17.63 27.28-22.64M411.91 279.48l23.32 13.46M347.41 242.24l-8.4-4.85",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M359.6 469.79h51.24M413.09 326.84l26.3 49.36"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest4);
export default __webpack_public_path__ + "static/media/test4.4bd6dbb335d94c1cf14c669092cf85c3.svg";
export { ForwardRef as ReactComponent };